import _ from 'lodash';
import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Element, scroller } from 'react-scroll';
import classnames from 'classnames';
// import TransitionGroup from 'react-transition-group/TransitionGroup';
import Transition from 'react-transition-group/Transition';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import cookie from 'react-cookies';

import Segment from '../../../../components/Segment';
import { authenticateUser } from '../../../../store/auth';
import Spinner from '../../../../components/Spinner/';
import Logo from '../../components/Logo';
import CardForm from '../../components/CardForm';
import Background from '../../components/Background';
import Checkbox from '../../components/Checkbox';

import {
  choosingCareerIcon,
  pursuingCareerIcon,
  securingInterviewsIcon,
  interviewingSuccessfullyIcon,
} from './svg';

import './style.scss';
import '../../styles/input.scss';
import '../../styles/select.scss';

const segment = new Segment();

const SubmitAssessmentQuestionsMutation = gql`
  mutation(
    $Interests: [UserIndustryInput!]!
    $DesiredHelp: String!
    $CurrentSchoolStage: String!
    $OtherInterest: String!
  ) {
    submitAssessmentQuestions(
      Questions: {
        desired_help: $DesiredHelp
        current_school_stage: $CurrentSchoolStage
        other_interest: $OtherInterest
      }
      Interests: $Interests
    ) {
      status
    }
  }
`;

const registerUserQueryRaw = `
mutation($Email: String!, $trackURL: String, $TrackURL_Landed: String) {
  createUser(input: { 
    email: $Email,     
    trackUrl: $trackURL,
    initialLanding: $TrackURL_Landed
    userType: 2,
  }) {
    token
    user {
      id
    }
  }
}
`;

const duration = 150;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
  display: 'none',
};

const transitionStyles = {
  entering: { display: 'block', opacity: 0 },
  entered: { display: 'block', opacity: 1 },
  exiting: { display: 'block', opacity: 0 },
  exited: { display: 'none', opacity: 0 },
};

const Fade = ({ in: inProp, children }) => (
  <Transition in={inProp} timeout={duration}>
    {state => (
      <div
        style={{
          ...defaultStyle,
          ...transitionStyles[state],
        }}
      >
        {children}
      </div>
    )}
  </Transition>
);

// NOTE: these are hard-mapped to `industry_id` in the `industries` table
const INTERESTS = [
  {
    label: 'Finance',
    value: 178,
  },
  {
    label: 'Management Consulting',
    value: 5,
  },
  {
    label: 'Marketing & Advertising',
    value: 46,
  },
  {
    label: 'Data Science',
    value: 7,
  },
  {
    label: 'Software Development',
    value: 160,
  },
  {
    label: 'Product Management',
    value: 167,
  },
  {
    label: 'Entrepreneurship & Startups',
    value: 21,
  },
];

class Questions extends React.Component {
  state = {
    selectedHelp: '',
    selectedStage: '',
    otherInterests: '',
    selectedInterests: [],
    email: '',
    password: '',
    isFetching: false,
    isExistingUser: false,
    nextQuestion: '',
  };

  checkedInterests = new Set();

  componentDidUpdate(prevProps, prevState) {
    const { nextQuestion, isExistingUser } = this.state;
    if (nextQuestion && nextQuestion !== prevState.nextQuestion) {
      this.scrollTo(nextQuestion);
    }

    if (isExistingUser && !prevState.isExistingUser) {
      setTimeout(() => {
        this.passwordInput.focus();
        this.scrollTo('cta');
      }, 0);
    }
  }

  // XHR

  async fetchRedirect() {
    const { authedUser } = this.props;

    // Identify user
    if (
      _.isPlainObject(authedUser) &&
      _.has(authedUser, 'id') &&
      _.has(authedUser, 'email')
    ) {
      // console.log('segment.identify', authedUser.id, authedUser.email);
      segment.alias(authedUser.id);
      segment.identify(authedUser.id, {
        email: authedUser.email,
      });
    }

    segment.track('step4_clicked_continue');

    const {
      selectedHelp,
      selectedStage,
      selectedInterests,
      otherInterests,
    } = this.state;

    console.log('SAVING', selectedHelp, selectedStage, selectedInterests);

    const interests = selectedInterests.map(selectedInterest => {
      return {
        industry_id: selectedInterest,
        type: 'interest',
      };
    });

    try {
      this.setState({
        isFetching: true,
      });

      const response = await this.props.SubmitAssessmentQuestions({
        variables: {
          DesiredHelp: selectedHelp,
          CurrentSchoolStage: selectedStage,
          Interests: interests,
          OtherInterest: otherInterests,
        },
      });

      console.log('SAVED', response);

      this.props.router.push({
        pathname: '/assessment/loading',
        state: {
          selectedHelp,
        },
      });
    } catch (err) {
      // Suppress error
    } finally {
      this.setState({
        isFetching: false,
      });
    }
  }

  async fetchRegister() {
    let success = false;
    try {
      this.setState({
        isFetching: true,
      });

      const response = await axios.post(
        __GraphQLPublic, // eslint-disable-line no-undef
        {
          query: registerUserQueryRaw,
          variables: {
            Email: this.state.email,
            trackURL: window.location.href,
            TrackURL_Landed: cookie.load('InitialLanding_URL'),
          },
        },
        {
          headers: {
            authorization: 'Bearer unauthed',
          },
        },
      );
      const token = _.get(response, 'data.data.createUser.token');
      this.props.authenticateUser(token);
      success = true;
    } catch (err) {
      const errMessage = _.get(err, 'response.data.errors.0.message');
      if (errMessage === 'User already exists') {
        this.setState({
          isExistingUser: true,
        });
      } else {
        // Suppress error
        console.log('REGISTER ERROR', err);
      }
      success = false;
    } finally {
      this.setState({
        isFetching: false,
      });
    }

    return success;
  }

  async fetchLogin() {
    const { email, password } = this.state;
    // console.log(email, password);

    let success = false;
    try {
      this.setState({
        isFetching: true,
      });

      // eslint-disable-next-line no-undef
      const response = await axios.post(__AuthLink, {
        email,
        password,
      });
      const token = _.get(response, 'data.token');
      this.props.authenticateUser(token);
      success = true;
    } catch (err) {
      // Suppress error
      console.log('LOGIN ERROR', err);
      success = false;
    } finally {
      this.setState({
        isFetching: false,
      });
    }

    return success;
  }

  scrollTo(elementName, duration = 500, delay = 0, smooth = 'easeInOutQuint') {
    setTimeout(() => {
      scroller.scrollTo(elementName, {
        duration,
        delay,
        smooth,
      });
    }, 0);
  }

  // Handlers

  handleKeyPressAuth = event => {
    if (event.keyCode === 13 || event.charCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      this.handleCTA();
    }
  };

  handleCTA = async () => {
    const { isAuthenticated } = this.props;
    if (isAuthenticated) {
      await this.fetchRedirect();
      return;
    }

    let success = false;
    const { isExistingUser } = this.state;
    if (isExistingUser) {
      success = await this.fetchLogin();
    } else {
      success = await this.fetchRegister();
    }

    if (success) {
      await this.fetchRedirect();
    }
  };

  handleChangeEmail = event => {
    this.setState({
      email: event.target.value,
      nextQuestion: event.target.value ? 'cta' : 'auth',
    });
  };

  handleChangePassword = event => {
    this.setState({
      password: event.target.value,
      nextQuestion: event.target.value ? 'cta' : 'auth',
    });
  };

  handleClickHelp = selectedHelp => {
    let eventName = '';
    switch (selectedHelp) {
      case 'choosing-a-career':
        eventName = 'step1_clicked_choosing';
        break;
      case 'developing-my-career':
        eventName = 'step1_clicked_developing';
        break;
      case 'securing-more-interviews':
        eventName = 'step1_clicked_securing';
        break;
      case 'interviewing-successfully':
        eventName = 'step1_clicked_interviewing';
        break;
    }
    if (eventName) {
      segment.track(eventName);
    }

    this.setState({
      selectedHelp,
      nextQuestion: 'stage',
    });
  };

  handleChangeStage = event => {
    const selectedStage = event.target.value;

    let eventName = '';
    switch (selectedStage) {
      case 'freshman':
        eventName = 'step2_freshman';
        break;
      case 'sophomore':
        eventName = 'step2_sophomore';
        break;
      case 'junior':
        eventName = 'step2_junior';
        break;
      case 'senior':
        eventName = 'step2_senior';
        break;
      case 'graduate-student':
        eventName = 'step2_graduate';
        break;
      case 'early-career-professional':
        eventName = 'step2_earlycareer';
        break;
    }
    if (eventName) {
      segment.track(eventName);
    }

    this.setState({
      selectedStage,
      nextQuestion: 'interests',
    });
  };

  handleChangeOtherInterests = event => {
    const otherInterests = event.target.value;
    const { selectedInterests } = this.state;
    const hasInterests = selectedInterests.length || otherInterests.length;
    const { isAuthenticated } = this.props;

    this.setState({
      otherInterests,
      nextQuestion: hasInterests
        ? isAuthenticated ? 'cta' : 'auth'
        : 'interests',
    });
  };

  handleChangeInterests = option => {
    if (this.checkedInterests.has(option.value)) {
      this.checkedInterests.delete(option.value);
    } else {
      this.checkedInterests.add(option.value);

      let eventName = '';
      switch (option.value) {
        // Finance
        case 178:
          eventName = 'step3_finance';
          break;
        // Management Consulting
        case 5:
          eventName = 'step3_consulting';
          break;
        // Marketing & Advertising
        case 46:
          eventName = 'step3_marketingadvertising';
          break;
        // Data Science
        case 7:
          eventName = 'step3_datascience';
          break;
        // Software Development
        case 160:
          eventName = 'step3_programming';
          break;
        // Product Management
        case 167:
          eventName = 'step3_product';
          break;
        // Entrepreneurship & Startups
        case 21:
          eventName = 'step3_entrepreneurship';
          break;
      }
      if (eventName) {
        segment.track(eventName);
      }
    }

    const selectedInterests = Array.from(this.checkedInterests);
    const { otherInterests } = this.state;
    const hasInterests = selectedInterests.length || otherInterests.length;
    const { isAuthenticated } = this.props;

    this.setState({
      selectedInterests,
      nextQuestion: hasInterests
        ? isAuthenticated ? 'cta' : 'auth'
        : 'interests',
    });
  };

  // Inputs

  getCheckbox = ({ label, value }) => {
    return (
      <Checkbox
        key={value}
        label={label}
        value={value}
        onChange={this.handleChangeInterests}
      />
    );
  };

  getSelectStage() {
    return (
      <div className="assessment__select">
        <select
          name="stage"
          value={this.state.selectedStage}
          onChange={this.handleChangeStage}
          required
        >
          <option value="" disabled>
            I'm currently a....
          </option>
          <option value="freshman">Freshman</option>
          <option value="sophomore">Sophomore</option>
          <option value="junior">Junior</option>
          <option value="senior">Senior</option>
          <option value="graduate-student">Graduate Student</option>
          <option value="early-career-professional">
            Early Career Professional
          </option>
        </select>
      </div>
    );
  }

  // Cards

  getCardHelp() {
    const { selectedHelp } = this.state;

    return (
      <CardForm
        title="Step 1 of 3"
        subtitle="What do you need the most help with?"
      >
        <div className="questions__box--container">
          <div className="questions__box--outer">
            <div
              className={classnames({
                'questions__box--inner': true,
                'questions__box--inner-active':
                  selectedHelp === 'choosing-a-career',
              })}
              onClick={() => this.handleClickHelp('choosing-a-career')}
            >
              <div className="questions__icon">{choosingCareerIcon}</div>
              <div className="questions_textWrap">Choosing a career</div>
            </div>
          </div>
          <div className="questions__box--outer">
            <div
              className={classnames({
                'questions__box--inner': true,
                'questions__box--inner-active':
                  selectedHelp === 'developing-my-career',
              })}
              onClick={() => this.handleClickHelp('developing-my-career')}
            >
              <div className="questions__icon">{pursuingCareerIcon}</div>
              <div className="questions_textWrap">Developing my career</div>
            </div>
          </div>
          <div className="questions__box--outer">
            <div
              className={classnames({
                'questions__box--inner': true,
                'questions__box--inner-active':
                  selectedHelp === 'securing-more-interviews',
              })}
              onClick={() => this.handleClickHelp('securing-more-interviews')}
            >
              <div className="questions__icon">{securingInterviewsIcon}</div>
              <div className="questions_textWrap">Securing more interviews</div>
            </div>
          </div>
          <div className="questions__box--outer">
            <div
              className={classnames({
                'questions__box--inner': true,
                'questions__box--inner-active':
                  selectedHelp === 'interviewing-successfully',
              })}
              onClick={() => this.handleClickHelp('interviewing-successfully')}
            >
              <div className="questions__icon">
                {interviewingSuccessfullyIcon}
              </div>
              <div className="questions_textWrap">
                Interviewing successfully
              </div>
            </div>
          </div>
        </div>
      </CardForm>
    );
  }

  getCardStage() {
    const { selectedHelp } = this.state;
    const show = !!selectedHelp;

    return (
      <Fade in={!!show}>
        <Element name="stage">
          <CardForm
            title="Step 2 of 3"
            subtitle="What stage of school or work are you at?"
          >
            {this.getSelectStage()}
          </CardForm>
        </Element>
      </Fade>
    );
  }

  getCardInterests() {
    const { selectedHelp, selectedStage } = this.state;
    const show = selectedHelp && selectedStage;

    return (
      <Fade in={!!show}>
        <Element name="interests">
          <CardForm
            title="Step 3 of 3"
            subtitle="What careers are you interested in?"
          >
            <div>{INTERESTS.map(this.getCheckbox)}</div>
            <div className="assessment__input">
              <input
                type="text"
                placeholder="Enter other careers"
                value={this.state.otherInterests}
                onChange={this.handleChangeOtherInterests}
              />
            </div>
          </CardForm>
        </Element>
      </Fade>
    );
  }

  getEmailInput() {
    return (
      <div className="assessment__input">
        <input
          type="text"
          value={this.state.email}
          placeholder="Your email"
          onChange={this.handleChangeEmail}
          onKeyPress={this.handleKeyPressAuth}
        />
      </div>
    );
  }

  getPasswordInput() {
    return (
      <div className="assessment__input">
        <input
          type="password"
          value={this.state.password}
          placeholder="Your password"
          onChange={this.handleChangePassword}
          onKeyPress={this.handleKeyPressAuth}
          ref={input => {
            this.passwordInput = input;
          }}
        />
      </div>
    );
  }

  getCardAuth() {
    // If already authenticated, don't show
    const { isAuthenticated } = this.props;
    if (isAuthenticated) {
      return null;
    }

    const {
      selectedHelp,
      selectedStage,
      selectedInterests,
      otherInterests,
      isExistingUser,
    } = this.state;
    const hasInterests = selectedInterests.length || otherInterests.length;
    const show = selectedHelp && selectedStage && hasInterests;

    const title = isExistingUser
      ? 'Please login to your existing account'
      : 'Enter your email to access your matches';

    return (
      <Fade in={!!show}>
        <Element name="auth">
          <CardForm title={title}>
            {this.getEmailInput()}
            {isExistingUser && this.getPasswordInput()}
          </CardForm>
        </Element>
      </Fade>
    );
  }

  // Other

  getHeading() {
    const { isAuthenticated } = this.props;
    const welcomeText = isAuthenticated ? 'Welcome back' : 'Welcome';
    return (
      <div className="questions__heading">
        {welcomeText}! Let’s find you an advisor
      </div>
    );
  }

  getCTA() {
    const { isAuthenticated } = this.props;
    const {
      selectedHelp,
      selectedStage,
      selectedInterests,
      otherInterests,
      email,
      isFetching,
      isExistingUser,
    } = this.state;
    const hasInterests = selectedInterests.length || otherInterests.length;
    const hasEmail = email.length;
    const show =
      selectedHelp &&
      selectedStage &&
      hasInterests &&
      (hasEmail || isAuthenticated);

    const buttonComponent = isFetching ? (
      <Spinner className="spinner--white" />
    ) : isExistingUser ? (
      'Login'
    ) : (
          'Continue'
        );

    return (
      <Fade in={!!show}>
        <Element name="cta">
          <div className="questions__cta">
            <button
              className="btn btn-paragon-one"
              onClick={this.handleCTA}
              disabled={isFetching}
            >
              {buttonComponent}
            </button>
          </div>
        </Element>
      </Fade>
    );
  }

  render() {
    return (
      <div>
        <Background />
        <Logo />
        <div className="assessment__wrapper--narrow">
          {this.getHeading()}
          <div className="questions__cards">
            {this.getCardHelp()}
            {this.getCardStage()}
            {this.getCardInterests()}
            {this.getCardAuth()}
          </div>
          {this.getCTA()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authedUser: _.get(state, 'auth.User'),
  isAuthenticated: !!_.get(state, 'auth.sub'),
});

const mapDispatchToProps = {
  authenticateUser,
};

export default store => ({
  path: 'questions',
  component: connect(mapStateToProps, mapDispatchToProps)(
    compose(
      graphql(SubmitAssessmentQuestionsMutation, {
        name: 'SubmitAssessmentQuestions',
      })(Questions),
    ),
  ),
});



// WEBPACK FOOTER //
// ./src/routes/assessment/routes/Questions/index.js